<template>
    <router-view :pmsConnDetails="pmsConnDetails"></router-view>
</template>
<script>
export default {
  props: {
    pmsConnDetails: Object,
  },
}
</script>